import React from "react";

interface PageLoaderProps {
  message?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({
  message = "Loading..."
}) => {

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/50 backdrop-blur-md">
      <div className="mb-4">
        <span
          className="dcalligraphy text-white text-4xl md:text-5xl font-normal animate-pulse"
          style={{
            transform: 'rotate(-8deg)',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          Weddn.co
        </span>
      </div>
      <p className="text-gray-300 text-sm">{message}</p>
    </div>
  );
};

export default PageLoader;